import React, {Component} from 'react'
import DefaultTab from './DefaultTab'
import CreateClassOneModal from 'template/Modals/CreateClassOne'
import __R, {userCan} from 'containers/__R';
import {fetchClass} from 'containers/pages/Class/ducks'
import {connect} from 'react-redux'
import FilterBy from 'template/FilterBy';
import locale from './locale'
import './ClassOne.scss'
import {
	PanelWrapper,
	Tab,
	Tabs,
	TabList,
	TabPanel
} from 'components/UI'

const FILTERS = ['text:searchKeyword'];

const FILTER_OPTIONS = {
  'text:searchKeyword': {
    placeholder: __('Search Private Class', locale),
    valueMinLength: 2,
  }
}
const mapStateToProps = (state) => ({
  classList: state.classList
})

const mapDispatchToProps = (dispatch) => {
  return {
    fetchClass: (opts) => dispatch(fetchClass(opts)),
  }
}

class ClassOne extends Component {
  constructor(props){
    super(props)

    this.state = {
      selectedOption: '',
      selectedIndex: 0,
      orderBy: 0,
      filterData:{},
      keyword: ''
    }

    this.onSelectTab = this.onSelectTab.bind(this)
    this.onFilterChange = this.onFilterChange.bind(this)
  }

  onFilterChange({ filterData }){
    const schoolId = localStorage.getItem('schoolId')
    const {selectedIndex, orderBy} = this.state
    const {itemsCountPerPage} = this.props.classList.pagination;

    this.setState({
      filterData,
      keyword: filterData['searchKeyword']
    },
      ()=>{
        this.props.fetchClass({
          schoolId,
          type: '1on1',
          state: selectedIndex == 0 ? 'current' : 'archived',
          keyword: this.state.keyword,
          amount_per_page: itemsCountPerPage,
          current_page_number: 1,
          order_by: orderBy
        })
      }
    )
  }

  onSelectTab(selectedIndex){
    const { orderBy } = this.state;

    this.setState({
      selectedIndex, 
      orderBy: orderBy, 
      filterData: {
        ...this.state.filterData,
        searchKeyword: '',
      },
      keyword: ''
    })
  }

  render(){
    const schoolId = localStorage.getItem('schoolId')
    const {activePage, itemsCountPerPage} = this.props.classList.pagination;
    const {selectedOption, selectedIndex, filterData, keyword, orderBy} = this.state;
    return (
      <PanelWrapper className='class-one-container'>
        <div>
          {__("Private Class List", "classone")}
        </div>
        <Tabs defaultIndex={selectedIndex} onSelect={this.onSelectTab}>
          <TabList>
            <Tab>{__('Current', locale)}</Tab>
            <Tab>{__('Closed', locale)}</Tab>
            <__R can='create_private_class' by='disable'>
              <button className=" btn btn-primary pull-right createBtn" onClick={()=>{
                CreateClassOneModal({mode: 'create'})
                .then(() => {
                  this.setState({
                    filterData: {
                      ...this.state.filterData,
                      searchKeyword: '',
                    },
                    keyword: ''
                  },()=>{
                    this.props.fetchClass({
                      schoolId,
                      type: '1on1',
                      state: selectedIndex == 0 ? 'current' : 'archived',
                      amount_per_page: itemsCountPerPage,
                      current_page_number: activePage,
                      order_by: orderBy
                    })
                  })
                })
              }}>
              {__("New Private Class", "classone")}
              </button>
            </__R>
            <div className='pull-right'>
              <FilterBy
                filterData={filterData}
                filters={FILTERS}
                options={FILTER_OPTIONS}
                onChange={this.onFilterChange} />
            </div>
            <select className='form-control sort-by pull-right' value={orderBy} disabled={selectedOption} onChange={(e) => {
              this.setState({orderBy: e.target.value}, ()=>{
                this.props.fetchClass({
                  schoolId,
                  type: '1on1',
                  state: selectedIndex == 0 ? 'current' : 'archived',
                  amount_per_page: itemsCountPerPage,
                  current_page_number: activePage,
                  order_by: this.state.orderBy,
                  keyword
                })
              })
            }}>
              <option key='0' value='0'>{__('Creation Time: Newest to Oldest', locale)}</option>
              <option key='1' value='1'>{__('Creation Time: Oldest to Newest', locale)}</option>
              <option key='2' value='2'>{__('Name: A-Z', locale)}</option>
              <option key='3' value='3'>{__('Name: Z-A', locale)}</option>
            </select>
            <div className='pull-right sort-by-label'>{__('Sort by', locale)}</div>
          </TabList>

          <TabPanel>
            <DefaultTab classState={'current'} orderBy={orderBy} keyword={keyword}/>
          </TabPanel>
          <TabPanel>
            <DefaultTab classState={'archived'} orderBy={orderBy} keyword={keyword}/>
          </TabPanel>
        </Tabs>
      </PanelWrapper>
    )
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(ClassOne)



// WEBPACK FOOTER //
// ./src/containers/pages/ClassOne/index.js